import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AgentApiAllianceSettingShow } from '@/types/serializers';
import { ALLIANCE_SETTING_QUERY_KEY } from './useFetchAllianceSetting';

interface UpdateAllianceSettingParams {
  is_enabled?: boolean;
  slug?: string | null;
  terms_of_service_url?: string | null;
  max_agents?: number;
}

export default function useUpdateAllianceSetting() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdateAllianceSettingParams) => {
      const response = await fetch('/agent/api/alliance_setting', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({ alliance_setting: params }),
      });

      if (!response.ok) {
        let errorMessage = 'アライアンス設定の更新に失敗しました';
        try {
          const errorData: { error?: string; errors?: string[] } = await response.json();
          errorMessage = errorData.errors?.[0] || errorData.error || errorMessage;
        } catch {
          // JSONパースに失敗した場合はデフォルトメッセージを使用
        }
        throw new Error(errorMessage);
      }

      const data: AgentApiAllianceSettingShow = await response.json();
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ALLIANCE_SETTING_QUERY_KEY });
    },
  });
}
